/**
 * Đồng bộ với qrcode-management: trace id cho luồng guest / merge QR.
 */
import { GUEST_QR_STORAGE_DAYS } from "./constant";

const TRACE_ID_KEY = "qr_guest_flow_request_id";
const TRACE_AT_KEY = "qr_guest_flow_started_at";
const TRACE_TTL_MS = GUEST_QR_STORAGE_DAYS * 24 * 60 * 60 * 1000;
const TRACE_ID_PREFIX = "qr-merge-v1";

const canUseStorage = () =>
  typeof window !== "undefined" && typeof window.sessionStorage !== "undefined";

const now = () => Date.now();

const randomPart = () => {
  let value = "";
  while (value.length < 8) {
    value += Math.random().toString(36).slice(2);
  }
  return value.slice(0, 8);
};

const createTraceId = () => `${TRACE_ID_PREFIX}-${now()}-${randomPart()}`;

const isExpired = (startedAt) => !startedAt || now() - startedAt > TRACE_TTL_MS;

export const getQrGuestFlowTraceId = () => {
  if (!canUseStorage()) return null;

  const traceId = window.sessionStorage.getItem(TRACE_ID_KEY);
  const startedAt = Number(window.sessionStorage.getItem(TRACE_AT_KEY) || 0);

  if (!traceId || isExpired(startedAt)) {
    return null;
  }

  return traceId;
};

export const startQrGuestFlowTraceId = () => {
  const traceId = createTraceId();
  if (canUseStorage()) {
    window.sessionStorage.setItem(TRACE_ID_KEY, traceId);
    window.sessionStorage.setItem(TRACE_AT_KEY, String(now()));
  }
  return traceId;
};

export const ensureQrGuestFlowTraceId = () =>
  getQrGuestFlowTraceId() || startQrGuestFlowTraceId();
